


















































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import * as user from "../../_store/user.module";
import * as data from "../../_store/data.module";
import { InstituteInfo } from "../../_models/instituteInfo";
import { bus } from "../../main";
import * as temp from "../../_store/temp.module";
import { UserInfo } from "../../_models/userInfo";
import DownloadRecords from "../DownloadRecords.vue";

@Component({
  components: {
    DownloadRecords
  }
})
export default class AssignAreeDataTable extends Vue {
  @Prop() params!: any;
  @Prop() createDialogParams!: object;
  @Prop() recordType!: any;
  @Prop() userInfo!: UserInfo;
  @Prop() listaAree!: any;

  private loadingData: boolean;
  private search: string;

  private articolazioni: any;
  private articolazioneFilter: string;
  private aree: any;
  private areeFilter: string;

  private filters: any;

  constructor() {
    super();
    this.loadingData = false;
    this.search = "";
    this.articolazioni = this.params.listaArticolazioni;
    this.articolazioneFilter = "Tutte";
    this.aree = this.params.listaAree;
    this.areeFilter = "Tutte";

    this.filters = {
      fitroArticolazione: "",
      filtroArea: ""
    };
  }

  @Watch("articolazioneFilter")
  onArticolazioneChange(value: string) {
    this.filterChange();
  }

  @Watch("areeFilter")
  onGiornoChange(value: string) {
    this.filterChange();
  }

  filterChange() {
    // var filters = {
    //   fitroArticolazione: ""
    // };
    // if (this.params.filterType === "listaOfferteAllievo") {
    this.filters = {
      fitroArticolazione: this.articolazioneFilter,
      filtroArea: this.areeFilter
    };
    bus.$emit("filtroAssegnazioneAree", this.filters);
    // }
  }

  changed() {
    bus.$emit("assegnazioneAreeChanged");
  }

  deleteAssegnazioneAllievo(idAssegnazione: number) {
    var payload = {
      idAssegnazione: idAssegnazione
    };
    user
      .dispatchDeleteAssegnazioneAreaAllievo(this["$store"], payload)
      .then(() => {
        bus.$emit(
          "successfullOperation",
          "Assegnazione cancellata correttamente"
        );
        bus.$emit("loadAssegnazioniAllieviAree")
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", error.response.statusText);
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", error.response.statusText);
        }
      });
  }

  deleteAssegnazioneAzienda(idAssegnazione: number){
    var payload = {
      idAssegnazione: idAssegnazione
    };
    user
      .dispatchDeleteAssegnazioneAreaAzienda(this["$store"], payload)
      .then(() => {
        bus.$emit(
          "successfullOperation",
          "Assegnazione cancellata correttamente"
        );
        bus.$emit("loadAssegnazioniAziendeAree")
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", error.response.statusText);
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", error.response.statusText);
        }
      });
  }

  created() {
    bus.$on("dataLoadedAssegnazioni", () => {
      this.loadingData = false;
    });

    bus.$on("saveAssegnazioniAreaAziende", () => {
      this.articolazioneFilter = "Tutte";
      this.areeFilter = "Tutte";
    });

    bus.$on("saveAssegnazioniAreaAllievi", () => {
      this.articolazioneFilter = "Tutte";
      this.areeFilter = "Tutte";
    });
  }
}
